export default "__VITE_ASSET__CHRoVssj__"